'use client'

import React, { ReactNode, useEffect, useState, useRef } from "react"
import HolidayStayCard from '@/components/holidayStay/Card'
import BafadCard from '@/components/bafad/Card'
import JobCard from '@/components/job/Card'
import SchoolThematicCard from '@/components/school/schoolThematic/Card'
import SchoolActivityCard from '@/components/school/schoolActivity/Card'
import SchoolStayCard from '@/components/school/schoolStay/Card'
import PressArticleCard from '@/components/pressArticle/Card'
import PostCard from '@/components/post/Card'
import PublicationCard from '@/components/publication/Card'
import EducationCourseCard from '@/components/educationCourse/Card'
import AccomodationCard from '@/components/accomodation/Card'
import { useInView } from 'react-intersection-observer'
import Loading from "@/components/loading/Loading"
import { usePathname, useSearchParams } from "next/navigation"
import { getSearchFnByObject } from "@/services/search"
import moment from "moment"

type ResultsListProps = {
    aroeven: Aroeven,
    object: string,
    initialResults: Searchable[],
    initialCount: number,
    searchParams?: any
}

export default function ResultsList({
    aroeven,
    object,
    initialResults = [],
    initialCount,
    searchParams
}: ResultsListProps) {

    const init = useRef(false)

    const { ref, inView } = useInView()
    //const searchParams = useSearchParams()

    /*const [results, setResults] = useState((console.log('usestate') !== null && typeof window === 'undefined') ? initialResults : ('results_list' in window.history.state ? window.history.state.results_list.results : initialResults))
    const [page, setPage] = useState(typeof window === 'undefined' ? 1 : ('results_list' in window.history.state ? window.history.state.results_list.page : 1))
    const [count, setCount] = useState(typeof window === 'undefined' ? initialCount : ('results_list' in window.history.state ? window.history.state.results_list.count : initialCount))*/
    const [results, setResults] = useState(initialResults)
    const [page, setPage] = useState(1)
    const [count, setCount] = useState(initialCount)
    const [addedSearchParams, setAddedSearchParams] = useState<any>({})

    const getMoreResults = async () => {
        const next = page + 1

        const searchFn = getSearchFnByObject(object)

        const { items, count } = await searchFn(aroeven, {
            ...searchParams,
            page: next
        })
        setCount(count)
        setResults([
            ...results,
            ...items
        ])
        setPage(next)
    }

    useEffect(() => {
        if (inView) {
            getMoreResults()
        }
    }, [inView])

    /*useEffect(() => {
        //if (init.current === false || typeof window === 'undefined') return
        setResults(initialResults)
    }, [searchParams])*/

    useEffect(() => {
        if (init.current === false) return
        try {
            window.history.replaceState({
                ...history.state,
                results_list: {
                    results,
                    count,
                    page
                }
            }, '')
        }
        catch (error) {}
    }, [results])

    useEffect(() => {
        if (typeof window === 'undefined') return
        if ('results_list' in window.history.state === false) return
        console.log('useEffect', window.history.state)
        setResults(window.history.state.results_list.results)
        setPage(window.history.state.results_list.page)
        setCount(window.history.state.results_list.count)
    }, [])

    useEffect(() => {
        if (init.current === false) {
            init.current = true
        }
    }, [])

    return (
        <>
            {results.map((result: any, indexResult: number) => {
                return (
                    <React.Fragment key={indexResult}>
                        <div className={(['HolidayStay', 'Bafad', 'SchoolStay', 'SchoolActivity', 'SchoolThematic', 'Job', 'Publication'].includes(object)) ? "col-sm-6 col-xl-4" : "col-sm-6 col-lg-4 col-xl-3"}>
                            <div className={object === 'SchoolThematic' ? '' : "vignette h-100"}>
                                {object === 'HolidayStay' &&
                                    <HolidayStayCard
                                        holidayStay={result}
                                        filters={{
                                            ...searchParams?.minDate && moment(searchParams.minDate, 'YYYY-MM-DD').isValid() && {
                                                minDate: searchParams.minDate
                                            },
                                            ...searchParams?.maxDate && moment(searchParams.maxDate, 'YYYY-MM-DD').isValid() && {
                                                maxDate: searchParams.maxDate
                                            }
                                        }}
                                    />
                                }
                                {object === 'Bafad' &&
                                    <BafadCard
                                        bafad={result}
                                    />
                                }
                                {object === 'EducationCourse' &&
                                    <EducationCourseCard
                                        educationCourse={result as EducationCourse}
                                    />
                                }
                                {object === 'SchoolThematic' &&
                                    <SchoolThematicCard
                                        schoolThematic={result}
                                    />
                                }
                                {object === 'SchoolActivity' &&
                                    <SchoolActivityCard
                                        schoolActivity={result}
                                    />
                                }
                                {object === 'SchoolStay' &&
                                    <SchoolStayCard
                                        accomodation={result}
                                    />
                                }
                                {object === 'Accomodation' &&
                                    <AccomodationCard
                                        accomodation={result}
                                    />
                                }
                                {object === 'Job' &&
                                    <JobCard
                                        job={result}
                                    />
                                }
                                {object === 'PressArticle' &&
                                    <PressArticleCard
                                        aroeven={aroeven}
                                        pressArticle={result}
                                    />
                                }
                                {object === 'Post' &&
                                    <PostCard
                                        aroeven={aroeven}
                                        post={result}
                                    />
                                }
                                {object === 'Publication' &&
                                    <PublicationCard
                                        aroeven={aroeven}
                                        publication={result}
                                    />
                                }
                            </div>
                        </div>
                    </React.Fragment>
                )
            })}
            {results.length < count &&
                <div ref={ref}>
                    <Loading />
                </div>
            }
            {/*{results.length >= Math.min(count, 24) && results.length < count &&
                <h1>Voir plus</h1>
            }*/}
        </>
    )
}